import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService } from 'src/app/Services/initalLoader.service';
import { SuperAdminApiService } from 'src/app/Services/superAdmin.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-initial-loader',
  templateUrl: './initial-loader.component.html',
  styleUrls: ['./initial-loader.component.scss']
})
export class InitialLoaderComponent implements OnInit, OnDestroy {

  displayLogo : string;
  private logoSub: Subscription;

  constructor(public loaderService: LoaderService, private superAdminService: SuperAdminApiService) {
  }

  ngOnInit() {
    this.logoSub = this.superAdminService.logoUpdated.subscribe(logo => {
      this.displayLogo = logo;
    
    });
  }

  ngOnDestroy() {
    if (this.logoSub) {
      this.logoSub.unsubscribe();
    }
  }

}
